import { TERMS } from "../../utils/terms-data/term";
import { Box, Typography, useTheme } from "@mui/material";
// import { tokens } from "../../theme";

// import useMediaQuery from "@mui/material/useMediaQuery";

const TextTerm = () => {
	// const theme = useTheme();
	// const colors = tokens(theme.palette.mode);
	// const isNonMobile = useMediaQuery("(min-width: 800px)");

	return (
		<Box>
			<Box sx={{ textAlign: "justify" }}>
				<div style={{ marginTop: "5px" }}>
					<b>Cláusula Primeira.</b> Em razão da{" "}
					<b style={{ textDecoration: "underline" }}>
						utilização das ferramentas tecnológicas
					</b>{" "}
					disponibilizadas pela <b>Consignante</b>, por meio deste
					sítio eletrônico, a <b>Consignatária</b> fará a coleta e uso
					(tratamento) de <b>Dados Pessoais</b> de terceiros,{" "}
					<b>Clientes</b>, pelos quais se responsabiliza
					integralmente, na forma da legislação pátria vigente, em
					especial, mas não somente, LGPD - Lei Geral Proteção de
					Dados Pessoais (Lei nº 13.709/2018), Código Civil (Lei Nº
					10.406, de 10 de janeiro de 2002), Código Penal (Decreto-Lei
					nº 2.848, de 7 de dezembro de 1940), assim como pelas
					disposições deste Temo.
				</div>

				<div style={{ marginTop: "10px" }}>
					<b>Cláusula Segunda.</b> O tratamento dos dados aqui
					referidos se dará com o escopo único e exclusivo de
					adimplemento, pelos <b>Clientes</b>, à <b>Pitaya</b>, dos
					valores atinentes aos <b>Produtos</b> adquiridos, ou seja,
					para cadastro e pagamento, do <b>Cliente</b>, na plataforma
					da <b>Pitaya</b>;
				</div>

				<div style={{ marginTop: "10px" }}>
					<b>Cláusula Terceira.</b> As credenciais de acesso (login e
					senha) fornecidas à <b>Consignatária</b> são de uso pessoal
					desta, intrasferível, e de conhecimento exclusivo, sendo de{" "}
					<b>sua inteira responsabilidade</b> todo e qualquer prejuízo
					causado pelo fornecimento da senha pessoal à terceiros,
					independente do motivo, ou mesmo sua utilização por
					terceiros, ainda que não fornecidas propositalmente a estes;
				</div>

				<div style={{ marginTop: "10px" }}>
					<b>Cláusula Quarta.</b> Para os fins de utilização das
					ferramentas tecnológicas fornecidas, serão consideradas
					confidenciais todas as informações transmitidas por meios
					escritos, eletrônicos, verbais ou quaisquer outros e de
					qualquer natureza;
				</div>

				<div style={{ marginTop: "10px" }}>
					<b>Cláusula Quinta.</b> É proibida a cópia de qualquer
					informação de <b>Clientes</b> para dispositivos estranhos à
					estrutura do Sistema disponibilizado pela <b>Pitaya</b>, bem
					como a divulgação, compartilhamento e uso, exceto se a
					referida ação seja estritamente necessária para a prestação
					dos serviços contratados, devendo ser realizada com a maior
					segurança possível e com expressa e prévia autorização do
					representante legal da <b>Pitaya</b>;
				</div>

				<div style={{ marginTop: "10px" }}>
					<b>Cláusula Sexta.</b> Os prejuízos, de qualquer natureza,
					causados pela <b>Consignatária</b> à <b>Pitaya</b>, ao
					sistema ou aos <b>Clientes</b>, em razão da quebra de
					confidencialidade, integridade, ou utilização indevida das
					informações e dados acessados, são de{" "}
					<b style={{ textDecoration: "underline" }}>
						inteira responsabilidade da Consignatária
					</b>
					, que se compromete com o imediato reembolso/pagamento dos
					prejuízos causados, que poderão, ainda, ser reclamados
					judicialmente, caso em que arcará, ainda, com custas e
					honorários advocatícios.
				</div>

				<div style={{ marginTop: "10px" }}>
					<b>Cláusula Sétima.</b> Para fins deste instrumento, os
					termos “Operador”, “Controlador”, “Dados Pessoais”, “Dados
					Pessoais Sensíveis”, “Tratamento”, “Titular”, dentre as
					outras elencadas no artigo 5 da Lei Geral de Proteção de
					Dados (“LGPD”), terão o mesmo significado definido na Lei.
				</div>

				<div style={{ marginTop: "10px", paddingBottom: "20px" }}>
					<b>Cláusula Oitava. </b>A <b>Consignatária</b> se compromete
					a: (i) coletar, processar, compartilhar ou realizar
					quaisquer atividades de tratamento aos dados pessoais
					relacionados ao presente Contrato em acordo com as leis,
					regulamentos e melhores práticas acerca da segurança, da
					confidencialidade e da proteção dos Dados Pessoais, em
					especial as disposições da LGPD - Lei Geral de Proteção de
					Dados Pessoais (Lei nº 13.709/2018) para a proteção desses
					dados pessoais e a preservação da privacidade dos
					respectivos titulares, (ii) restringir o tratamento de dados
					pessoais sob seu controle às situações em que haja
					finalidade lícita e embasamento legal adequado, e enquanto
					essas finalidades justificarem o seu tratamento; (iii)
					cumprir políticas e normas internas aplicáveis quanto ao
					tratamento de dados pessoais bem como as leis e regulamentos
					sobre a matéria; (iv) manter encarregado pelo tratamento de
					dados pessoais e canais de comunicação exclusivos para
					contato dos titulares de dados pessoais e autoridades com
					relação ao exercício de direitos e exigência de deveres
					relacionados à privacidade e proteção de dados; e (v)
					manter-se adequadas à LGPD conforme as melhores práticas de
					privacidade, segurança, confidencialidade e proteção dos
					Dados Pessoais aplicáveis ao setor.
				</div>
			</Box>
		</Box>
	);
};

export default TextTerm;
